// src/pages/TermsPage.js
import React from 'react';
import { FileText, AlertTriangle, Scale, Key } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold text-center mb-8">תנאי שימוש</h1>
      
      <div className="bg-white rounded-lg shadow-lg p-6 space-y-8">
        {/* הקדמה */}
        <section>
          <p className="text-gray-600">
            ברוכים הבאים לאתר משרד עורכי דין מיכלסון. השימוש באתר זה ובתכניו כפוף לתנאים המפורטים להלן. 
            עצם השימוש באתר מהווה הסכמה מצדך לתנאים אלה.
          </p>
        </section>

        {/* הצהרת אחריות משפטית */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <AlertTriangle className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-2">הצהרת אחריות משפטית</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  התוכן באתר זה נועד לספק מידע כללי בלבד ואינו מהווה ייעוץ משפטי, 
                  חוות דעת מקצועית או תחליף לייעוץ אישי מול עורך דין.
                </p>
                <p>
                  השימוש במידע המפורסם באתר זה נעשה באחריות המשתמש בלבד. 
                  בעלי האתר, מפעיליו ועובדיו אינם נושאים באחריות לכל נזק שייגרם 
                  כתוצאה מהסתמכות על המידע המפורסם באתר.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* יחסי עורך דין-לקוח */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <Scale className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-2">יחסי עורך דין-לקוח</h2>
              <p className="text-gray-600">
                פנייה דרך האתר או השימוש במידע שבו אינם יוצרים יחסי עורך דין-לקוח ביניכם לבין המשרד. 
                יחסים אלו נוצרים רק לאחר פגישה אישית וחתימה על הסכם ייצוג משפטי מפורש.
              </p>
            </div>
          </div>
        </section>

        {/* פרטיות ואבטחת מידע */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <Key className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-2">פרטיות ואבטחת מידע</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  השימוש באתר כפוף למדיניות הפרטיות שלנו. אנו מתחייבים לשמור על פרטיותכם 
                  ולהשתמש במידע שתמסרו רק למטרות המפורטות במדיניות הפרטיות.
                </p>
                <p>
                  כל הנתונים המוזנים בטפסים באתר מועברים באופן מאובטח באמצעות פרוטוקול HTTPS.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* קניין רוחני */}
        <section className="mt-8 space-y-4">
          <h2 className="text-xl font-bold mb-2">קניין רוחני</h2>
          <div className="space-y-4 text-gray-600">
            <p>
              כל התכנים המופיעים באתר, לרבות טקסטים, תמונות, סימנים מסחריים וסמלילים,  
              הינם רכושו הבלעדי של משרד עורכי דין מיכלסון או של צדדים שלישיים שהעניקו למשרד רישיון שימוש בהם.
            </p>
            <p>
              אין להעתיק, לשכפל, להפיץ, לפרסם או להשתמש בתכנים המופיעים באתר ללא אישור מפורש מראש ובכתב.
            </p>
          </div>
        </section>

        {/* שינויים בתנאי השימוש */}
        <section className="space-y-4">
          <h2 className="text-xl font-bold mb-2">שינויים בתנאי השימוש</h2>
          <p className="text-gray-600">
            אנו שומרים לעצמנו את הזכות לעדכן ולשנות את תנאי השימוש מעת לעת, לפי שיקול דעתנו הבלעדי. 
            שינויים אלו יכנסו לתוקף מיד עם פרסומם באתר.
          </p>
        </section>

        {/* יצירת קשר */}
        <section className="mt-8 pt-8 border-t">
          <p className="text-gray-600">
            לכל שאלה או בירור בנוגע לתנאי השימוש באתר, ניתן ליצור קשר באמצעות 
            <a href="/contact" className="text-blue-600 hover:text-blue-800 mx-1">טופס יצירת הקשר</a>
            שלנו.
          </p>
        </section>

        {/* עדכון אחרון */}
        <div className="text-sm text-gray-500 mt-8">
          תנאי השימוש עודכנו לאחרונה: ינואר 2024
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
